import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogData } from 'src/app/models/dialog/dialog.model';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {
 message = "TableTemplate.AlertDialog.Message";
  message2 = null;
  confirmButtonText = "TableTemplate.ConfirmationDialog.AcceptButton";
  cancelButtonText = "TableTemplate.ConfirmationDialog.CancelButton";

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private dialogRef: MatDialogRef<AlertDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.message = this.data.message || this.message;
      this.message2 = this.data.message2;
      if (this.data.buttonText) {
        this.confirmButtonText =
          this.data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText =
          this.data.buttonText.cancel || this.cancelButtonText;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
